import { Icon, IconProps } from '@chakra-ui/react';

export const ToastErrorIcon = (props: IconProps) => (
  <Icon width='51px' height='52px' viewBox='0 0 51 52' fill='none' {...props}>
    <circle cx='25.6636' cy='25.9739' r='25.1313' fill='white' />
    <path
      d='M31.034 37H36.814L28.586 25.338L36.304 14.322H30.49L25.356 22.074L20.154 14.322H14.408L22.126 25.372L13.898 37H19.644L25.356 28.704L31.034 37Z'
      fill='#E53E51'
    />
  </Icon>
);
